import React from "react";
import { Facet } from "@elastic/react-search-ui";
import MultiCheckboxFacet from "../MultiCheckboxFacet/MultiCheckboxFacet";
import { useTranslation } from "react-i18next";

const OmronDoubtFacet = () => {
  const { t } = useTranslation();
  return (
    <div className="l-localnav j-nav">
      <h2 className="c-title--main border">{t("FAQ Category")}</h2>
      <Facet
        field="field_faq_question_categories"
        label={""}
        show={1000}
        view={(props) => (
          <MultiCheckboxFacet
            {...props}
            fieldName="field_faq_question_categories"
          />
        )}
      />
    </div>
  );
};

export default OmronDoubtFacet;
